import React from "react";
import { SonicDBEntry } from "../../common/classes/SonicDBEntry";

import wrap_style from "./TeamMember.module.scss";
import DBListItem from "../../common/db-list/DBListItem";
import { genTermNames } from "../../utils/GeneralUtils";

type Props = {
  team_member?: Array<SonicDBEntry>;
  team_color?: string;
  logo_src?: string;
};

export const TeamMember: React.FC<Props> = (props) => {
  const { team_member, team_color } = props;

  return (
    <div className={wrap_style["f-teamMember"]}>
      <div className={wrap_style["f-teamMember__list"]}>
        {team_member?.map((member, index) => {
          const tags: Array<string> = [];
          if (member.player_type) {
            for (const type of member.player_type) {
              tags.push(type.name);
            }
          }
          return (
            <DBListItem
              key={index}
              to={`/person/${member.id}`}
              tags={
                member.player_type
                  ? genTermNames(member.player_type)
                  : undefined
              }
              name={member.name}
              img_src={member.imgs?.[0]?.medium?.url}
              team_color={team_color}
              isStudent={member.school ? true : false}
              verified={member.verified}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TeamMember;
